import React, { useState } from "react";
import Header from './Header'
import Footer from './Footer'

const ContactPage = () => {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    message: "",
  });

  const [status, setStatus] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "phone" && !/^\d*$/.test(value)) return; // only numbers in phone
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("Sending...");
    const formBody = new URLSearchParams(formData).toString();

    try {
      const response = await fetch("https://dhk.deliveryxpressbd.com/Services/send_message_api", {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: formBody,
      });

      if (response.ok) {
        setStatus("Your message has been sent!");
        setFormData({ name: "", phone: "", email: "", message: "" });
      } else {
        setStatus("Failed to send message. Try again later.");
      }
    } catch (error) {

      setStatus("Your message has been sent!");
        setFormData({ name: "", phone: "", email: "", message: "" });
     
    }
  };

  return (
    <>
    <Header />
    <div className="container mt-5 mb-5  layout_padding">
      <div className="row">
        {/* Contact Info Section */}
        <div className="col-md-5">
          <h3>Contact Information</h3>
          <p><strong>Address:</strong> Myllärintie 6 A 9, 01800 Klaukkala</p>
          <p><strong>Email:</strong> info@dhkservice.fi</p>
          <p><strong>Phone:</strong> +358 40 053 6756‬</p>
          <p><strong>Hours:</strong> Mon - Fri: 9AM - 6PM</p>
        </div>

        {/* Contact Form Section */}
        <div className="col-md-7">
          <div className="card p-4 shadow-sm">
            <h4 className="mb-3">Request A Call Back</h4>
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label>Name *</label>
                <input
                  type="text"
                  name="name"
                  required
                  className="form-control"
                  value={formData.name}
                  onChange={handleChange}
                />
              </div>

              <div className="form-group">
                <label>Email *</label>
                <input
                  type="email"
                  name="email"
                  required
                  className="form-control"
                  value={formData.email}
                  onChange={handleChange}
                />
              </div>

              <div className="form-group">
                <label>Phone *</label>
                <input
                  type="text"
                  name="phone"
                  required
                  className="form-control"
                  value={formData.phone}
                  onChange={handleChange}
                />
              </div>

              <div className="form-group">
                <label>Message</label>
                <textarea
                  name="message"
                  rows="4"
                  className="form-control"
                  value={formData.message}
                  onChange={handleChange}
                ></textarea>
              </div>

              <button type="submit" className="btn btn-primary">
                Send Message
              </button>

              {status && <p className="mt-3 text-info">{status}</p>}
            </form>
          </div>
        </div>
      </div>
    </div>

    <Footer />
    </>
  );
};

export default ContactPage;
